import React from 'react'

import BankAccount from './BankAccount'
import BankWire from './BankWire'
import CreditDebit from './CreditDebit'

import { PaymentMethodsEnum } from 'pages/RegA/PaymentSelection'
import { IFormProps } from '../../../../interfaces'

const Payments = (props: IFormProps) => {
  const renderPaymentSelected = () => {
    switch (props.paymentOptionSelected) {
      case PaymentMethodsEnum.ACH:
        return <BankAccount {...props} />
      case PaymentMethodsEnum.CARD:
        return <CreditDebit {...props} />
      case PaymentMethodsEnum.WIRE:
        return <BankWire {...props} />
      default:
        return <CreditDebit {...props} />
    }
  }

  return <div>{renderPaymentSelected()}</div>
}

export default Payments
